import { carouselInit } from './carousel';
import themeEditor from './themeEditor';

const HeroCarousel = () => {
  const heroCarousels = document.querySelectorAll('[data-hero-carousel]');
  if (heroCarousels.length === 0) {
    return;
  }

  // Initialize all carousels on page load and add them to the index
  heroCarousels.forEach((carousel) => {
    const section_id = carousel.parentElement.parentElement.getAttribute('data-section-id');
    carouselInit(section_id, carousel);
  });

  themeEditor();
};

export { HeroCarousel };
